import { useEffect, useState } from "react";
import { IFormSection, TSubmitType } from "../../types/common";
import {
  API_CHARTS_OF_ACCOUNTS_ALL,
  API_LEDGERS,
  API_SUPPLIER_CONFIGURABLES,
} from "../../utils/apis";
import { URL_LEDGERS } from "../../utils/urls";
import useGet from "../common/useGet";
import { getResultOptions } from "../../utils/helpers";

export type TFormCustomProps = {
  id?: number;
  submitType?: TSubmitType;
};

export const useLedgersForm = () => {
  const [supplierName, setSupplierName] = useState("");

  const sections: IFormSection[] = [
    {
      title: "Ledgers Information",
      fields: [
        {
          field_name: "transaction_date",
          type: "date",
          label: "Transaction Date",
        },
        {
          field_name: "debit_account",
          type: "select",
          label: "Debit Account Type",
          options_name: "accounts",
          props: { required: true },
        },
        {
          field_name: "amount",
          type: "number",
          label: "Debit Amount",
          props: { required: true },
        },
        {
          field_name: "credit_account",
          type: "select",
          label: "Credit Account Type",
          options_name: "credit_accounts",
          props: { required: true },
        },
        {
          field_name: "supplier",
          type: "select",
          label: "Supplier",
          props: {
            onInput: (e) => setSupplierName(e.target.value),
          },
          options_name: "suppliers",
        },
        {
          field_name: "tax",
          type: "input",
          label: "Tax",
        },
        {
          field_name: "description",
          type: "textarea",
          label: "Description",
          props: { required: true, wide: true },
        },
      ],
    },
  ];

  const redirect = `${URL_LEDGERS}`;

  const getConfigOptions = () => {
    const { loadData: getAccounts, data: accounts } = useGet();
    const { loadData: getCreditAccounts, data: creditAccounts } = useGet();
    const { loadData: getSuppliers, data: suppliers } = useGet();
    useEffect(() => {
      getAccounts({
        api: API_CHARTS_OF_ACCOUNTS_ALL,
        params: {},
      });
      getCreditAccounts({
        api: API_CHARTS_OF_ACCOUNTS_ALL,
        params: { is_fines_account: false },
      });
    }, []);

    useEffect(() => {
      getSuppliers({
        api: API_SUPPLIER_CONFIGURABLES,
        params: { name: supplierName },
      });
    }, [supplierName]);

    return {
      accounts: getResultOptions(accounts, "account_name"),
      credit_accounts: getResultOptions(creditAccounts, "account_name"),
      suppliers: getResultOptions(suppliers, "name"),
    };
  };

  const options = getConfigOptions();

  return { sections, redirect, options };
};

export function submitLedgers(payload: any, id: number | null) {
  //  on update
  if (id) {
    return {
      id,
      api: API_LEDGERS,
      params: payload,
    };
  }
  // on create
  return {
    api: API_LEDGERS,
    params: payload,
  };
}
